<template>
    <div :class="modeClass" class="list">
        <div class="list-left">
            <div class="list-img">
            </div>
            <p class="label-xl">{{ this.placeholder }}</p>
        </div>
        <p class="label-xl">{{ this.label }}</p>
    </div>
</template>

<style scoped>
.list {
    display: flex;
    padding: 8px 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    width: 100%;
}

.list-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.list-img {
    background: url(/src/assets/img/card-img-placeholder.webp);
    background-size: cover;
    width: 48px;
    height: 48px;
    border-radius: var(--border-radius-xxs);
}
</style>

<script>
export default {
    name: 'ListMComponent',
    props: {
        placeholder: {
            type: String,
            required: true
        },
        label: {
            type: [Number, String],
            required: true,
            default: ''
        },
        classVariant: {
            type: Number,
            default: 0
        },
    },
    computed: {
        modeClass() {
            return {
                'semantic-danger': 1 === this.classVariant,
            };
        }
    }
}
</script>